import isEmpty from "lodash/isEmpty";
import isObject from "lodash/isObject";
import pickBy from "lodash/pickBy";

import { objectContainsKeywords } from "..";

const assetLeadsFilter = (assetLeads, params = {}) => {
  const and =
    (...funcs) =>
    (...innerArgs) =>
      funcs.every((func) => func(...innerArgs));
  const filters = {
    pointPersonID: (id) => (assetLead) => assetLead.pointPerson.id === parseInt(id, 10),
    status:
      (statusFilter) =>
      ({ status }) =>
        statusFilter === "all" || statusFilter === status,
    keywords: (keywords) => (assetLead) => objectContainsKeywords(assetLead, keywords),
    default: () => () => true,
  };
  const nonEmptyParams = pickBy(params, (p) => (isObject(p) ? !isEmpty(p) : !!p)); // eslint-disable-line
  const usedFilters = Object.keys(nonEmptyParams).map((k) =>
    (filters[k] || filters.default)(params[k])
  ); // eslint-disable-line

  return assetLeads.filter(and(...usedFilters));
};

export default assetLeadsFilter;
